import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { isNumber } from '../utils/validationUtils';

class PMCATable extends Component {

    constructor(props) {
        super(props);

        this.state = { data: null };
        this.addRow = this.addRow.bind(this);
        this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
        this.sortData = this.sortData.bind(this);
    }


    componentDidMount() {
        this.setState({
            data: JSON.parse(this.props.data)
        }, () => this.sortData());
    }

    updateProperty(property, value) {
        let newData = this.state.data;
        newData[property] = value;
        this.setState({ data: newData });
    }

    sortData() {
        let data = [...this.state.data];
        data.sort((a, b) => a['pmcaScore'] > b['pmcaScore'] ? -1 : 1);
        data = data.map((element, index) => {return {...element, pmcaRank: index + 1}})
        this.setState({ data: data });
    }

    onTextEditorValueChange(field, props, modifiedRowIndex, modifiedField, value) {
        const nValue = Number(value);
        if(isNaN(nValue) || nValue > 1) {
            value = 1;
        } else if ( nValue < 0) {
            value = 0;
        }
        let updatedValues = [...props.value];
        if (modifiedField === 'probability') {
            updatedValues[modifiedRowIndex][modifiedField] = value;
            updatedValues[modifiedRowIndex]['pmcaScore'] = (value * updatedValues[modifiedRowIndex]['mcaScore']).toFixed(4);
        }
        this.updateProperty(field, updatedValues);
    }

    tableEditor(options) {
        return <InputText type="text" defaultValue={options.value} onChange={(e) => this.onTextEditorValueChange('kpis', options.props, options.rowIndex, options.field, e.target.value)} />;
    }

    addRow() {
        this.setState({data: [...this.state.data, {label: 'New Row', capex: '', opex: '', benefits: '', years: '', discount: ''}]})
    }

    deleteRow(rowData) {
        let newData = this.state.data;
        newData = newData.filter(element => element !== rowData);
        this.setState({ data: newData });
    }

    actionBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <Button icon="pi pi-trash" severity="danger" link style={{color: '#e91224', width: '20px', height: '20px'}} onClick={() => this.deleteRow(rowData)} />
            </React.Fragment>
        );
    }

    render() {
        return (
            <div>
                {this.state.data &&
                    <input id='pmca_table_data' type="hidden" value={JSON.stringify(this.state.data.map(element => { return { label: element.label, probability: element.probability }}))} />
                }
                <DataTable emptyMessage='Add new rows by using the button below.' value={this.state.data} editMode="cell">
                    <Column key='label' field='label' header='Name' />
                    <Column key='probability' field='probability' header='Probability' bodyClassName='probability-col' onCellEditComplete={this.sortData} editor={(options) => this.tableEditor(options)} />
                    <Column key='rank' field='rank' header='MCA Rank' />
                    <Column key='mcaScore' field='mcaScore' header='MCA Score' />
                    <Column key='pmcaRank' field='pmcaRank' header='PCMA Rank' />
                    <Column key='pmcaScore' field='pmcaScore' header='PCMA Score' />
                </DataTable>
            </div>
        );
    }
}



export default PMCATable;